export default "__VITE_ASSET__Cu6oU$vb__";